/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import PrescriptionSpecVital from './prescription-spec-vital';
import PrescriptionSpecVitalDetail from './prescription-spec-vital-detail';
import PrescriptionSpecVitalUpdate from './prescription-spec-vital-update';
import PrescriptionSpecVitalDeleteDialog from './prescription-spec-vital-delete-dialog';

const PrescriptionSpecVitalRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<PrescriptionSpecVital />} />
    <Route path="new" element={<PrescriptionSpecVitalUpdate />} />
    <Route path=":id">
      <Route index element={<PrescriptionSpecVitalDetail />} />
      <Route path="edit" element={<PrescriptionSpecVitalUpdate />} />
      <Route path="delete" element={<PrescriptionSpecVitalDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default PrescriptionSpecVitalRoutes;
